import { render, staticRenderFns } from "./u-tooltip-elevation-rounded-lg.vue?vue&type=template&id=6f55e5e6&scoped=true&"
import script from "./u-tooltip-elevation-rounded-lg.vue?vue&type=script&lang=js&"
export * from "./u-tooltip-elevation-rounded-lg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f55e5e6",
  null
  
)

export default component.exports